/*!

=========================================================
* Black Dashboard React v1.2.2
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.



*/
import React, { useEffect, useState } from "react";

// reactstrap components
import { Card, CardHeader, CardBody, CardTitle, Row, Col } from "reactstrap";
import HtmlContent from "components/Custom/htmlContent";
import content from 'content.json'; // Importing the JSON file


function Privacy() {
  const [fontAwesomeLoaded, setFontAwesomeLoaded] = useState(false);
  const [detectionComplete, setDetectionComplete] = useState(false);

  useEffect(() => {
    // Check if Font Awesome is loaded
    const checkFontAwesome = () => {
      // Method 1: Check if Font Awesome CSS is loaded
      const fontAwesomeSheets = Array.from(document.styleSheets).some(sheet => {
        try {
          return sheet.href && sheet.href.includes('font-awesome');
        } catch (e) {
          return false;
        }
      });

      // Method 2: Check if Font Awesome classes are working
      const testElement = document.createElement('i');
      testElement.className = 'fas fa-music';
      testElement.style.position = 'absolute';
      testElement.style.left = '-9999px';
      testElement.style.visibility = 'hidden';
      document.body.appendChild(testElement);
      
      const computedStyle = window.getComputedStyle(testElement, ':before');
      const content = computedStyle.getPropertyValue('content');
      
      document.body.removeChild(testElement);
      
      // More accurate detection: check if content actually contains a valid Font Awesome character
      // Font Awesome icons should have content like "\f001" (music note) or similar
      const hasValidContent = content && 
        content !== 'none' && 
        content !== '""' && 
        content !== '""' && 
        content !== '"\\0\\""' && 
        content.includes('\\f') && 
        content.length > 3;
      
      const isLoaded = fontAwesomeSheets && hasValidContent;
      
      // Font Awesome detection complete
      
      setFontAwesomeLoaded(isLoaded);
      setDetectionComplete(true);
    };

    // Check immediately
    checkFontAwesome();
    
    // Check again after delays to ensure Font Awesome has time to load
    const timer1 = setTimeout(checkFontAwesome, 500);
    const timer2 = setTimeout(checkFontAwesome, 1500);
    const timer3 = setTimeout(checkFontAwesome, 3000);
    
    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
      clearTimeout(timer3);
    };
  }, []);

  // Component ready

  return (
    <>
      <div className="content">
        <Row>
          <Col md="10">
            <Card>
              
              <CardBody>
                <div className="typography-line">
                  <h1>{content.brandname}</h1>
{/*                   
                  <HtmlContent html={content.calculation} />
                   */}
                {/* Process Explanation Block */}
                <div className="process-explanation-block">
                    <div className="process-header">
                        <h2 className="process-title">
                            <i className="fas fa-calendar-alt"></i>
                            How Your Personal Event Calendar Works
                        </h2>
                        <p className="process-subtitle">
                            Discover events that match your Spotify music taste
                        </p>
                    </div>
                    
                    <div className="process-steps">
                        <div className="process-step">
                            <div className="step-icon">
                                {detectionComplete && fontAwesomeLoaded ? (
                                    <i className="fas fa-music"></i>
                                ) : (
                                    <span>🎵</span>
                                )}
                            </div>
                            <div className="step-content">
                                <h4>1. Load artist names</h4>
                                <p>Load artist names from your <b>public</b> Spotify Playlist</p>
                            </div>
                        </div>
                        
                        <div className="process-step">
                            <div className="step-icon">
                                {detectionComplete && fontAwesomeLoaded ? (
                                    <i className="fas fa-search"></i>
                                ) : (
                                    <span>🔍</span>
                                )}
                            </div>
                            <div className="step-content">
                                <h4>2. Matching Algorithm</h4>
                                <p>Our matching algorithm matches your playlist artists with the artists performing at the upcoming THE Dance Event Festival in Amsterdam 2025.</p>
                            </div>
                        </div>
                        
                        <div className="process-step">
                            <div className="step-icon">
                                {detectionComplete && fontAwesomeLoaded ? (
                                    <i className="fas fa-calendar-check"></i>
                                ) : (
                                    <span>📅</span>
                                )}
                            </div>
                            <div className="step-content">
                                <h4>3. Personalized Results</h4>
                                <p>View events (by date) at THE Dance Event Festival in Amsterdam 2025 where your favorite artists are performing, ranked by your music preferences (most matches first).</p>
                            </div>
                        </div>
                        
                        <div className="process-step">
                            <div className="step-icon">
                                {detectionComplete && fontAwesomeLoaded ? (
                                    <i className="fas fa-external-link-alt"></i>
                                ) : (
                                    <span>🔗</span>
                                )}
                            </div>
                            <div className="step-content">
                                <h4>4. Direct Links & Details</h4>
                                <p>Click on any track to open it directly in Spotify, to listen to the track.</p>
                            </div>
                        </div>
                    </div>
                    
                    {/* <div className="process-note">
                        <i className="fas fa-info-circle"></i>
                        <p>
                            <strong>Privacy First:</strong> We only access your public Spotify data and never store your personal information.
                            You can disconnect your account at any time.
                        </p>
                    </div> */}
                </div>
                  <div className="video-container">
                  <iframe width="100%" height="1190" src="https://www.youtube.com/embed/irBUe8nbnJM" title="September 1, 2025" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                  </div>
                  
                  
                  <br />
                  
                  {/* <HtmlContent html={content.features.features} />
                  <HtmlContent html={content.features.benefits} /> */}
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default Privacy;
